export const SET_DOCUMENT_MANAGEMENT_TABLE_EXCLUDED_COLS = 'SET_DOCUMENT_MANAGEMENT_TABLE_EXCLUDED_COLS';

export const documentManagementTableColsUpdate = data => dispatch => {
  dispatch(({ type: SET_DOCUMENT_MANAGEMENT_TABLE_EXCLUDED_COLS, payload: { documentManagementTableExcludedCols: data} }));
};



// WEBPACK FOOTER //
// ./src/reducers/document_management/actions.js